/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAppAction } from "../appAction";
import { exploreActions } from "./explore-action";
import { getDefaultExploreState, IExploreState } from "./explore-state";

const handlers = {
  [exploreActions.FETCH_ALL_TAGS]: (
    state: IExploreState
  ): IExploreState => {
    return { ...state, tags: [], tagsLoading: true };
  },

  [exploreActions.FETCH_ALL_TAGS_SUCCESS]: (
    state: IExploreState,
    { tags }: any
  ): IExploreState => {
    return { ...state, tags, tagsLoading: false, tagsError: null };
  },

  [exploreActions.FETCH_ALL_TAGS_ERROR]: (
    state: IExploreState,
    error: Error
  ): IExploreState => {
    return { ...state, tagsLoading: false, tagsError: error };
  },
};

export const exploreReducer = (
  state: IExploreState = getDefaultExploreState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) : state;
};
